// code对应的情况
export const checkVerifyCode = (code) => {
  switch (code) {
    case 101:
      return "手机号未注册";
    // case 102:
    //   return '指定的邮箱不存在';
    case 103:
      return "该手机号已存在，请您直接登录";
    // case 104:
    //   return '用于开户的电子邮箱已存在';
    case 105:
      return "手机号不能为空";
    case 106:
      return "验证码类型为空";
    case 107:
      return "验证码已过期";
    case 108:
      return "手机号未注册";
    case 109:
      return "账号已被停用，如需启用请联系客服（400-820-6662）";
    case 110:
    case 120:
      return "发送验证码过于频繁";
    case 111:
      return "图形验证码无效";
    default:
      return "系统繁忙，请稍后重试";
  }
};

// 验证码类型
export const targetEnums = {
  OPEN: "OPEN", // 开户
  SIGN_IN: "SIGN_IN", // 登录
  ACTIVATION: "ACTIVATION", // 激活
  RESET_PASSWORD: "RESET_PASSWORD", // 重置密码
};

// 获取图片宽高
export function getBase64ImageSize(base64Data) {
  return new Promise((resolve, reject) => {
    const img = new Image();

    img.onload = function () {
      const width = img.width;
      const height = img.height;

      resolve({ width, height });
    };

    img.onerror = function () {
      reject(new Error("无法获取图片信息。"));
    };
    img.src = base64Data;
  });
}
